import { render, staticRenderFns } from "./CommessaList.vue?vue&type=template&id=6bd4449a&"
import script from "./CommessaList.vue?vue&type=script&lang=js&"
export * from "./CommessaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports